(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9861],{

/***/ 37144:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-reviews",
      function () {
        return __webpack_require__(16773);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ CustomerReviews; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 118 modules
var src = __webpack_require__(32014);
// EXTERNAL MODULE: ../../../libs/landing/feature-customer-reviews/src/lib/customer-reviews.module.css
var customer_reviews_module = __webpack_require__(96636);
var customer_reviews_module_default = /*#__PURE__*/__webpack_require__.n(customer_reviews_module);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 287 modules
var shared_src = __webpack_require__(40405);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../libs/landing/feature-customer-reviews/src/lib/components/intro/intro.module.css
var intro_module = __webpack_require__(54073);
var intro_module_default = /*#__PURE__*/__webpack_require__.n(intro_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-customer-reviews/src/lib/components/intro/intro.tsx


const Intro = ({ introText , title  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (intro_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: introText
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-customer-reviews/src/lib/components/intro/index.ts


// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/feature-customer-reviews/src/lib/components/customer-reviews-section/customer-reviews-section.module.css
var customer_reviews_section_module = __webpack_require__(39938);
var customer_reviews_section_module_default = /*#__PURE__*/__webpack_require__.n(customer_reviews_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-customer-reviews/src/lib/components/customer-reviews-section/customer-reviews-section.tsx



const ReviewSection = ({ reviewData , containerClass , contentClass  })=>{
    const title = reviewData.title;
    const body = (0,shared_src/* renderWithResolver */.be)(reviewData.text);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: containerClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: contentClass,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (customer_reviews_section_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customer_reviews_section_module_default()).body,
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (customer_reviews_section_module_default()).image,
                src: reviewData.image.filename,
                alt: reviewData.image.alt || ""
            })
        ]
    });
};
const CustomerReviewsSection = ({ howCinchWorks , faffFreeMotoring  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSection, {
                reviewData: howCinchWorks,
                containerClass: (customer_reviews_section_module_default()).howCinchWorksContainer,
                contentClass: (customer_reviews_section_module_default()).howCinchWorksContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSection, {
                reviewData: faffFreeMotoring,
                containerClass: (customer_reviews_section_module_default()).faffFreeMotoringContainer,
                contentClass: (customer_reviews_section_module_default()).faffFreeMotoringContent
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-customer-reviews/src/lib/customer-reviews.tsx










function CustomerReviews({ story , generatedAt , preview  }) {
    const { content  } = (0,storyblok_src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const { intro , SEO , HowCinchWorksComponent , FaffFreeMotoringComponent , PreFooterCta  } = content;
    const IntroSection = intro[0];
    const SeoSection = SEO[0];
    const HowCinchWorksSection = HowCinchWorksComponent[0];
    const FaffFreeMotoringSection = FaffFreeMotoringComponent[0];
    const PreFooterSection = PreFooterCta[0];
    const contentIntroText = (0,shared_src/* renderWithResolver */.be)(IntroSection.body);
    const router = (0,next_router.useRouter)();
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Customer Reviews -  click search all cars button`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "customer reviews page",
                    label: "button in page",
                    action: "view all cars"
                }
            }
        });
        router.push(PreFooterSection.CtaButton[0].url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SeoSection,
                generatedAt: generatedAt,
                fallbackTitle: "cinch reviews and customer testimonials",
                fallbackDescription: "Official cinch reviews from happy customers enjoying faff-free motoring. Don't just take our word for it - read cinch reviews now."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (customer_reviews_module_default()).root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Wrapper */.im, {
                        className: {
                            container: (customer_reviews_module_default()).teaserContainer
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro, {
                            introText: contentIntroText,
                            title: IntroSection.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Wrapper */.im, {
                        className: {
                            container: (customer_reviews_module_default()).teaserContainer
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* TrustpilotWidget */.cE, {
                            widget: src/* TrustpilotWidgetTemplates.grid */.sd.grid,
                            height: "500px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customer_reviews_module_default()).customerReviewsSectionContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerReviewsSection, {
                            howCinchWorks: HowCinchWorksSection,
                            faffFreeMotoring: FaffFreeMotoringSection
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FullWidthCTA */.S3, {
                        iconName: "search",
                        iconGradient: "galaxy",
                        iconSize: 41,
                        title: PreFooterSection.title,
                        subtitle: PreFooterSection.subtitle,
                        buttonLabel: PreFooterSection.CtaButton[0].label,
                        onButtonClick: handleClick
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var customer_reviews = ((/* unused pure expression or super */ null && (CustomerReviews)));

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-customer-reviews/src/lib/get-static-props.ts


async function getStaticPropsfn({ preview =false  }) {
    const ddMeta = {
        traceId: (0,datadog_server_src/* getTraceId */.Wj)(),
        traceTime: Date.now()
    };
    try {
        var ref, ref1;
        const story = await (0,storyblok_src/* getStoryBySlug */.OI)("customer-reviews", {
            version: preview ? "draft" : "published"
        });
        if (!story) {
            throw new Error("Customer review story not found");
        }
        const HeroProps = (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.Hero) === null || ref1 === void 0 ? void 0 : ref1[0];
        (0,datadog_server_src/* setTag */.YA)("response.code", 200);
        return {
            props: {
                ddMeta,
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    heroProps: HeroProps,
                    showBorderRadius: true
                }
            },
            revalidate: 300
        };
    } catch (error) {
        console.error(error);
        if (typeof error === "string" || error instanceof Error) {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        return {
            notFound: true,
            props: {
                ddMeta
            },
            revalidate: 30
        };
    }
}
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("customer-reviews.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-customer-reviews/src/index.ts



;// CONCATENATED MODULE: ./pages/customer-reviews.tsx
var __N_SSG = true;



/***/ }),

/***/ 39938:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"customer-reviews-section_title__pBIXs","body":"customer-reviews-section_body__GNujE","image":"customer-reviews-section_image__FVR_X","howCinchWorksContainer":"customer-reviews-section_howCinchWorksContainer__xyFLj","howCinchWorksContent":"customer-reviews-section_howCinchWorksContent__3GyTM","faffFreeMotoringContainer":"customer-reviews-section_faffFreeMotoringContainer___s1ZG","faffFreeMotoringContent":"customer-reviews-section_faffFreeMotoringContent__bAK1c"};

/***/ }),

/***/ 54073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"intro_heading__w_REu"};

/***/ }),

/***/ 96636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"customer-reviews_root__5DJ5N","teaserContainer":"customer-reviews_teaserContainer__w7qN5","trustPilotWidget":"customer-reviews_trustPilotWidget__G3jA_","customerReviewsSectionContainer":"customer-reviews_customerReviewsSectionContainer__sLABo"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(37144); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);